import { Injectable } from '@angular/core';
import QRCode from 'qrcode'
import { financialRound } from '../dave-data-module/entities/accounts-receivable-ledger.entity';
import { Buffer } from 'buffer';

@Injectable({
  providedIn: 'root'
})
export class QrCodeService {

  constructor() { }
    async getInvoiceQRCodeBase64(
        invoiceNumber: string,
        beneficiaryName: string,
        beneficiaryIBAN: string,
        beneficiaryBIC: string,
        amountCurrency: 'EUR',
        amount: number,
        type: 'png' | 'svg' = 'svg',
        ) {

        const qr = new EPCQRCode(
            'BCD',
            '002', // todo if europe '001'
            '1',
            'SCT',
            beneficiaryBIC,
            beneficiaryName,
            beneficiaryIBAN,
            amountCurrency,
            amount, // todo oder Netto?
            null,
            null,
            invoiceNumber,
        );
        if (type === 'png') {
            return  await qr.png();
        } else if (type === 'svg') {
            return await qr.svgBase64();
        }
    }
    async getTOTPQRCode(otpauthUri: string, type: 'png' = 'png') {
       return new TOTPQRCode(otpauthUri).png();
    }

}
export class TOTPQRCode {
    private readonly qrCode: string;
    constructor( public readonly otpauthUri: string) {
        this.qrCode = otpauthUri.trim();
    }
    async png() {
        return await QRCode.toDataURL(this.qrCode, {
            errorCorrectionLevel: 'Q',
            type: 'image/png',
            width: 256,
            // scale: 10,
            // quality: 0.3,
            // margin: 1,
            // color: {
            //     dark:"#010599FF",
            //     light:"#FFBF60FF"
            // }
        });
    }
}

export class EPCQRCode {
    private readonly _qrCode: string;
    constructor(
        private service: 'BCD' = 'BCD', // Service Tag
        /**
         * 001 = EWR mit Nicht-EWR-Ländern
         * 002 = nur EWR
         * @private
         */
        private version: '001' | '002' = '001', // Version: 001, 002
        /**
         * Zeichenkodierung
         *     1 = UTF-8
         *     2 = ISO 8859-1 Latin-1, Westeuropäisch
         *     3 = ISO 8859-2 Latin 2, Mitteleuropäisch
         *     4 = ISO 8859-4 Latin 4, Nordeuropäisch
         *     5 = ISO 8859-5 Kyrillisch
         *     6 = ISO 8859-7 Griechisch
         *     7 = ISO 8859-10 Latin-6, Nordisch
         *     8 = ISO 8859-15 Latin-9, Westeuropäisch
         */
        private encoding: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' = '2', // Character set: 1 = UTF-8, 2 = ISO 8859-1
        private transfer: 'SCT' | 'INST', // Identification: SCT = SEPA credit transfer, INST = SEPA Instant Credit Transfer
        private bic: string, //'PBNKDEFF', // BIC
        private name: string, // 'Max Muster', // Name of the beneficiary
        private iban: string, //'DE02100100100006820101', // IBAN
        private amountCurrency: 'EUR',
        private amount: number, // Amount (Format „EUR#.##“)
        /**
         * Zweck (vierstelliger Buchstabencode, optional)
         * BENE = Arbeitslosengeld (unwahrscheinlich im QR-Code)
         * DEPT = Einzahlung
         * GDDS = Einkauf/Verkauf von Ware
         * MTUP = Handy aufladen
         * PENS = Renten (unwahrscheinlich im QR-Code)
         * SALA = Gehalt (unwahrscheinlich im QR-Code)
         * TRAD = Handelsgeschäft
         */
        private purpose: 'BENE' | 'DEPT' | 'GDDS' | 'MTUP' | 'PENS' | 'SALA' | 'TRAD' | null = null,
        private remittanceRef: string | null = null, // Reference (strukturierter 25-Zeichen-Code gem. ISO 11649 RF Creditor Reference)
        private remittanceText: string | null = null, // Verwendungszweck (max of 140 characters)
        private information: string | null = null, // Optional hint to user max. 70 Zeichen
    ) {
        if (remittanceRef && remittanceRef.length > 25) {
            throw new Error('Remittance reference must not exceed 25 characters');
        }
        if (remittanceText && remittanceText.length > 140) {
            throw new Error('Remittance text must not exceed 140 characters');
        }
        if (information && information.length > 70) {
            throw new Error('Information must not exceed 70 characters');
        }
        if (remittanceRef && remittanceText) {
            throw new Error('Remittance reference and remittance text cannot be used together');
        }
        if (version === '001' && !bic) {
            throw new Error('BIC is required for version 001');
        }
        if (
            !service ||
            !version ||
            !encoding ||
            !transfer ||
            !name ||
            !iban ||
            !amountCurrency ||
            !amount
        ) {
            throw new Error('Missing required fields');
        }
        if (transfer === 'INST') {
            /**
             * INST is not supported (yet), see https://www.europeanpaymentscouncil.eu/document-library/guidance-documents/quick-response-code-guidelines-enable-data-capture-initiation
             */
            throw new Error('INST is not supported');
        }

        this._qrCode = `
${this.service}
${this.version}
${this.encoding}
${this.transfer}
${this.bic || ''}
${this.name}
${this.iban}
${this.amountCurrency}${financialRound(this.amount, 2)}
${this.purpose || ''}
${this.remittanceRef || ''}
${this.remittanceText || ''}
${this.information || ''}
`.trim();
    }
    async png() {
        return await QRCode.toDataURL(this._qrCode, {
            errorCorrectionLevel: 'M', // ist vorgeschrieben, sowie version <= 13
            type: 'image/png',
            scale: 10,
            // quality: 0.3,
            // margin: 1,
            // color: {
            //     dark:"#010599FF",
            //     light:"#FFBF60FF"
            // }
        });

    }
    async svgBase64() {
        const data = await this.svg();
        if (this.encoding !== '2' && this.encoding !== '1') {
            throw new Error('only encoding 1 and 2 are implemented for base64');
        }
        const base64Data = Buffer.from(data, this.encoding === '2' ? 'latin1' : 'utf8').toString('base64');
        return `data:image/svg+xml;base64,${base64Data}`;
    }
    async svg() {
        return await QRCode.toString(this._qrCode, {
            errorCorrectionLevel: 'M', // ist vorgeschrieben, sowie version <= 13
            type: 'svg',
            // quality: 0.3,
            // margin: 1,
            // color: {
            //     dark:"#010599FF",
            //     light:"#FFBF60FF"
            // }
        });
    }
}
